export default __webpack_public_path__ + "static/media/client46.8c81b844.png";